<template>
  <div :class="$style.support" v-loading="commentLoading">
    <header :class="$style.header">
      <div :class="$style.accessioncontainer">
        <h3 :class="$style.lable">ORDER ID : &nbsp;</h3>
        <h2
          :class="$style.status"
          v-if="
            this.getPendingOrderDetails && this.getPendingOrderDetails.order_id
          "
        >
          {{
            this.getPendingOrderDetails && this.getPendingOrderDetails.order_id
              ? this.getPendingOrderDetails.order_id
              : "--"
          }}
        </h2>

      </div>
      <div :class="$style.statuscontainer">
        <div :class="$style.combinedstatus">
          <div :class="$style.statusgroup">
            <h3 :class="$style.lable">Status : &nbsp;</h3>
            <h3
              :class="$style.status"
              v-if="
                this.getPendingOrderDetails &&
                this.getPendingOrderDetails.status
              "
            >
              {{ this.getPendingOrderDetails.status }}
            </h3>

          </div>
          <div class="movestatus">
            <el-dropdown
              class="status-dropdown"
              @command="
                (command) => changeStatus(command, this.getPendingOrderDetails)
              "
              v-if="isLabAdminUser"
            >
              <span class="el-dropdown-link">
                Move Status
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu class="status-dropdown-menu">
                  <el-dropdown-item
                    command="ACTIVE"
                    :disabled="getPendingOrderDetails.status === 'ACTIVE'"
                  >
                    ACTIVE
                  </el-dropdown-item>
                  <el-dropdown-item
                    command="PENDING"
                    :disabled="getPendingOrderDetails.status === 'PENDING'"
                  >
                    PENDING
                  </el-dropdown-item>
                  <el-dropdown-item
                    command="REJECTED"
                    :disabled="getPendingOrderDetails.status === 'REJECTED'"
                  >
                    REJECTED
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>

        <div
          :class="$style.reasongroup"
          v-if="
            this.getPendingOrderDetails && this.getPendingOrderDetails.reasons
          "
        >
          <h3 :class="$style.reasonlabel">Reasons : &nbsp;</h3>
          <div :class="$style.reasondescription">
            <div
              :class="$style.reasonstatusloop"
              v-for="(reason, index) in this.getPendingOrderDetails.reasons"
              :key="index"
            >
              <p :class="$style.reasonstatus">{{ reason }}</p>
            </div>
          </div>
        </div>
        <div
          :class="$style.reasongroup"
          v-if="this.orderInfo && this.orderInfo.reasons"
        >
          <h3 :class="$style.reasonlabel">Reasons : &nbsp;</h3>
          <div :class="$style.reasondescription">
            <div
              v-for="(reason, index) in this.orderInfo.reasons"
              :key="index"
              :class="$style.reasonstatusloop"
            >
              <p :class="$style.reasonstatus">{{ reason }}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div :class="$style.containermain" ref="scrollContainer">
      <div
        :class="$style.messagecontainer"
        v-for="(log, index) in this.pendingOrdersLogs"
        :key="index"
      >
        <div :class="$style.row">
          <div
            :style="{ backgroundColor: getClasses(log.user) }"
            class="circle-design"
          >
            <h2 :class="$style.name">
              {{
                log.user
                  ? log.user.first_name
                    ? log.user.first_name[0].toUpperCase()
                    : "--"
                  : "--"
              }}
            </h2>
          </div>
          <div :class="$style.messagecontainer1">
            <p :class="$style.message">
              {{ log.message ? log.message : log.description }}
            </p>
            <span :class="$style.attachmentmessage" v-if="log && log.file_path">
              <div class="attached_block">
                <img
                  src="@/assets/images/icons/chat-attachment-files-two.svg"
                  style="width: 30px"
                />
                <div
                  class="attached_file_name"
                  :title="log.metadata ? log.metadata.file_name : ''"
                >
                  {{ log.metadata ? log.metadata.file_name : "" }}
                </div>
              </div>
              <img
                @click="viewAttachment(log.file_path)"
                src="@/assets/images/icons/actions/view-inactive.svg"
                alt="icon"
                style="width: 22px; padding-right: 5px"
                :class="$style.downloadcursor"
              />
              <img
                @click="downloadReport(log)"
                :class="$style.downloadcursor"
                src="@/assets/images/icons/chat-download.svg"
                alt="icon"
                style="width: 28px"
              />
            </span>
          </div>
        </div>
        <div :class="$style.datetime">
          <h3 :class="$style.name">
            {{ log.created_at ? this.formatTimestamp(log.created_at) : "--" }}
          </h3>
        </div>
      </div>
    </div>
    <div :class="$style.message3">
      <div :class="$style.messageinput">
        <el-upload
          class="upload-demo"
          action=""
          :on-change="handleUpload"
          :auto-upload="false"
          accept=".pdf"
          :show-file-list="false"
        >
          <el-button class="chatprimarybtn" :disabled="checkOrderStatus">
            <img
              :class="$style.attachIcon"
              alt=""
              src="@/assets/images/icons/attach-icon.svg"
            />
          </el-button>
        </el-upload>
        <div :class="$style.message4">
          <el-input
            v-model="message"
            :class="$style.chatinput"
            placeholder="Your Message"
            :disabled="checkOrderStatus"
            @input="handleInput"
            @keyup.enter.prevent="addOrderComment"
          ></el-input>
        </div>
        <div :class="$style.actions">
          <el-button
            class="chatSendBtn"
            :disabled="checkOrderStatus || message == ''"
            @click="addOrderComment()"
          >
            <img
              class="chat-send-icon"
              alt=""
              src="@/assets/images/icons/send-icon.svg"
            />
          </el-button>
        </div>
      </div>
    </div>
  </div>
  <ReasonForStatusChange
    v-if="takeStatusChangeReasonDialog"
    v-on:close="takeStatusChangeReasonDialog = false"
    v-on:reasonSubmit="unsetOrderCompleteStatus"
    :width="40"
    :title="takeStatusChangeReasonDialogTitle"
  ></ReasonForStatusChange>
</template>
<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import axios from "axios";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import ReasonForStatusChange from "@/components/misc/OrderReasonForChange";
export default defineComponent({
  name: "Support",
  data() {
    return {
      message: "",
      commentLoading: false,
      pendingOrdersLogs: [],
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
    };
  },
  components: { ReasonForStatusChange },
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("clientPendingOrders", [
      "getPendingOrderDetails",
      "getPendingOrderLogs",
      "getAddCommentStatus",
      "getUploadAttachmentsStatus",
      "getUploadedFilePath",
      "getUploadedFileMetadata",
    ]),
    ...mapGetters("orders", [
      "getAttachmentUploadStatus",
      "getUpdateOrderStatus",
    ]),
    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),

    orderId() {
      return this.$route.params.order_id;
    },
    checkOrderStatus() {
      if (
        this.getPendingOrderDetails &&
        this.getPendingOrderDetails.status &&
        (this.getPendingOrderDetails.status == "PENDING" ||
          this.getPendingOrderDetails.status == "REJECTED")
      ) {
        return false;
      }
      return true;
    },
    isLabAdminUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = ["LAB_ADMIN", "LAB_MANAGER"];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
  },
  props: ["orderInfo"],
  mounted() {
    this.fetchOrderLogs();
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
  methods: {
    handleInput() {
      // Trim whitespace from both ends of the input value
      const trimmedValue = this.message.trim();

      // Check if the trimmed value is empty (contains only whitespace)
      if (trimmedValue.length === 0) {
        // If the input contains only whitespace, set the value to an empty string
        this.message = "";
      }
    },
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTop = container.scrollHeight;
    },
    async downloadReport(doc) {
      try {
        this.commentLoading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/fetchFileDownloadUrl",
          {
            path: doc.file_path,
          }
        );
        if (this.getFileDownloadUrl) {
          let url = this.getFileDownloadUrl.download_url;
          const fileName = doc.metadata
            ? doc.metadata.file_name
            : "Pending Rejection";
          const fileStream = await axios({
            url: url, //your url
            method: "GET",
            responseType: "blob", // important
          });
          const urlObject = window.URL || window.webkitURL;
          const downloadUrl = urlObject.createObjectURL(fileStream.data);
          //  .then((response) => {
          // const href = URL.createObjectURL(response.data);

          const link = document.createElement("a");
          link.href = downloadUrl;

          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          // });
        } else {
          errorNotification("Error in downloading report");
        }
        this.commentLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async handleUpload(file) {
      try {
        let data = {
          file: file.raw.name,
          file_type: file.raw.type,
          file_size: file.raw.size / 1000,
          order_id: this.orderId,
          type: "case-attachments-upload",
        };
        this.commentLoading = true;

        await this.$store.dispatch(
          "clientPendingOrders/uploadAttachment",
          data
        );
        if (this.getUploadAttachmentsStatus) {
          let params = {
            file: file.raw,
            upload_url: this.getUploadAttachmentsStatus,
          };
          await this.$store.dispatch(
            "orders/uploadDocumentToGeneratedUrl",
            params
          );
          if (this.getUploadedFilePath) {
            let params = {
              order_id: this.$route.params.order_id,
              file_path: this.getUploadedFilePath,
              metadata: this.getUploadedFileMetadata,
            };
            await this.$store.dispatch(
              "clientPendingOrders/addOrderLogs",
              params
            );
          }
          if (this.getAttachmentUploadStatus) {
            successNotification("File uploaded successfully");
            window.location.reload();
          } else {
            errorNotification("Error while uploading file");
          }
        } else {
          errorNotification("Error while uploading file");
        }
        this.commentLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    formatTimestamp(timestamp) {
      // Parse the timestamp
      const date = new Date(timestamp);

      // Get the time zone of the laboratory (for example, America/New_York)
      const labTimeZone =
        this.getProfileData && this.getProfileData.lab
          ? this.getProfileData.lab.timezone
          : "America/New_York"; // Replace this with your actual time zone
      const options = {
        timeZone: labTimeZone,
        month: "short", // Display full month name
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true, // Use 12-hour clock
      };

      const formattedDateTime = date.toLocaleString("en-US", options);

      return formattedDateTime;
    },
    getClasses(user) {
      const firstLetter =
        user && user.first_name ? user.first_name[0].toUpperCase() : null;
      const colorMap = {
        A: "#273480", // Default
        B: "#4A148C", // Indigo
        C: "#1A237E", // Blue
        D: "#0D47A1", // Light blue
        E: "#6A1B9A", // Deep purple
        F: "#006064", // Teal
        G: "#2E7D32", // Green
        H: "#558B2F", // Light green
        I: "#9E9D24", // Lime
        J: "#F9A825", // Yellow
        K: "#FF8F00", // Amber
        L: "#EF6C00", // Orange
        M: "#D84315", // Deep orange
        N: "#4E342E", // Brown
        O: "#424242", // Grey
        P: "#37474F", // Blue grey
        Q: "#263238", // Dark Blue grey
        R: "#bf1b39", // red
        S: "#000000", // Black
        T: "#212121", // Dark Grey
        U: "#5D4037", // Brown
        V: "#424242", // Grey
        W: "#455A64", // Blue Grey
        X: "#37474F", // Blue grey
        Y: "#263238", // Dark Blue grey
        Z: "#212121", // Dark Grey
      };
      return colorMap[firstLetter] || "#CCCCCC";
    },
    async fetchOrderLogs() {
      try {
        this.commentLoading = true;

        let params = {
          order_id: this.orderId,
        };
        await this.$store.dispatch(
          "clientPendingOrders/fetchPendingOrderLogs",
          params
        );
        if (this.getPendingOrderLogs) {
          this.pendingOrdersLogs = this.getPendingOrderLogs.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          this.pendingOrdersLogs.reverse();
        }
        this.updateViewStatus();
        this.commentLoading = false;
      } catch (err) {
        console.log(err);
      } finally {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },
    async addOrderComment() {
      try {
        if (this.message != "") {
          this.commentLoading = true;
          let params = {
            order_id: this.$route.params.order_id,
            message: this.message,
          };
          await this.$store.dispatch(
            "clientPendingOrders/addOrderLogs",
            params
          );
          if (this.getAddCommentStatus) {
            successNotification("Commment added successfully");
            this.message = "";
            // this.$emit("logSent", true);
            await this.fetchOrderLogs();
          } else {
            errorNotification("Error while adding comment");
          }
        }
        this.commentLoading = false;
      } catch (err) {
        console.log(err);
        this.commentLoading = false;
      } finally {
        this.commentLoading = false;
      }
    },
    async changeStatus(command, OrderData) {
      try {
        if (command == OrderData.status) {
          return;
        }
        this.takeStatusChangeReasonDialogTitle = command;
        let params = {
          status: command,
          id: OrderData._id,
        };
        if (
          OrderData.status == "ACTIVE" ||
          OrderData.status == "PENDING" ||
          OrderData.status == "REJECTED"
        ) {
          this.unsetCompleteStatusChangeCase = OrderData._id;
          this.toStatus = command;
          this.askReasonOnUnsetCompletedStatus();
        } else {
          await this.updateStatus(params);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async askReasonOnUnsetCompletedStatus() {
      this.takeStatusChangeReasonDialog = true;
    },
    async updateStatus(params, index) {
      try {
        this.commentLoading = true;

        await this.$store.dispatch("orders/changeOrderStatus", params, {
          root: true,
        });
        if (this.getUpdateOrderStatus && this.getUpdateOrderStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateOrderStatus.message,
          });
          this.$emit("statusUpdated", true);
        }
        this.commentLoading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async unsetOrderCompleteStatus(data) {
      let params = {
        id: this.unsetCompleteStatusChangeCase,
        status: this.toStatus,
        notes: data.notes,
      };
      if (data.reasons && data.reasons.length > 0) {
        params.reasons = data.reasons;
      }
      await this.updateStatus(params, this.caseIndex);
    },
    async updateViewStatus() {
      try {
        let params = {
          orderId: this.$route.params.order_id,
        };
        await this.$store.dispatch(
          "clientPendingOrders/updateNotificationViewStatus",
          params
        );
      } catch (err) {
        console.log(err);
      }
    },
    async viewAttachment(doc) {
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: doc,
      });

      let url = this.getFileDownloadUrl.download_url;
      window.open(url, "_blank");
    },
  },
});
</script>
<style module>
.accessionid {
  margin: 0;
  flex: 1;
  position: relative;
  font-size: inherit;
  line-height: 110%;
  text-transform: uppercase;
  font-weight: 500;
  font-family: inherit;
}
.accessioncontainer {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem 1rem 0.5rem;
}
.lable {
  margin: 0;
  position: relative;
  font-size: inherit;
  letter-spacing: -1px;
  line-height: 110%;
  text-transform: uppercase;
  font-weight: 500;
  font-family: inherit;
}
.status {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 110%;
  text-transform: capitalize;
  font-weight: 500;
  font-family: inherit;
  color: #ffb125;
}
.statusgroup {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.25rem;
}
.reasongroup {
  display: grid;
  grid-template-columns: 90px 1fr;
  align-items: start;
  padding: 7px 0 0px;
  margin-left: 0px;
}
.reasonlabel {
  text-transform: uppercase;
  margin-right: 0;
  font-size: 16px;
  color: #f24a55;
}
.reasonstatus {
  color: #0a2342;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: start;
  overflow-wrap: break-word;
}
.reasondescription {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.reasonstatusloop {
  padding: 0 2px;
}
.reasonstatusloop:not(:last-child) p:after {
  content: ",";
}
.changestatusdropdown {
  border-radius: 8px;
  background-color: transparent;
  border: 1px solid #bf1b39;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.625rem;
  gap: 0.625rem;
  font-family: Poppins;
  font-size: 0.875rem;
  color: #bf1b39;
}
.statuscontainer {
  align-self: stretch;
  background-color: #f2f6f9;
  /* display: flex; */
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.563rem 1rem;
  text-align: center;
  color: #000;
}
.combinedstatus {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.75rem;
  text-align: left;
  font-size: 1rem;
  color: #363636;
  font-family: Poppins;
}
.name {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 100%;
  text-transform: capitalize;
  font-weight: 400;
  font-family: inherit;
}
/* .user {
  border-radius: 80px;
  background-color: #273480;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.438rem 0.75rem;
} */
.message {
  margin: 0;
  flex: 1;
  position: relative;
  line-height: 130%;
  text-transform: capitalize;
}
.messagecontainer1 {
  flex: 1;
  border-radius: 24px 24px 0px 24px;
  background-color: #f6f7fb;
  /* display: flex; */
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-size: 0.875rem;
  color: #161616;
}

.messagecontainer:nth-child(even) .messagecontainer1 {
  background-color: #fff3f5;
}
.row {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.25rem;
}
.datetime {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.125rem;
  font-size: 0.75rem;
  color: #999;
}
.messagecontainer {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 0rem 1rem;
  gap: 0.375rem;
}
.user1 {
  border-radius: 80px;
  background-color: #bf1b39;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.438rem 0.75rem;
}
.messagecontainer2 {
  flex: 1;
  border-radius: 24px 24px 0px 24px;
  background-color: #fff3f5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-size: 0.875rem;
  color: #161616;
}
.date1 {
  margin: 0;
  position: relative;
  line-height: 100%;
  text-transform: capitalize;
}
.name2 {
  position: relative;
  line-height: 100%;
  text-transform: capitalize;
}
.message2 {
  flex: 1;
  position: relative;
  line-height: 130%;
  text-transform: capitalize;
}
.mesage {
  margin: 0;
  position: relative;
  line-height: 100%;
}
.dateandtime {
  margin: 0;
  position: relative;
  font-size: 0.75rem;
  line-height: 100%;
}
.statusupdatedetais {
  align-self: stretch;
  background-color: #e5f7ff;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding: 0.625rem;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: #000;
}
.containermain {
  align-self: stretch;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0rem 0rem 2.5rem;
  gap: 0.625rem;
}

.attachIcon {
  width: 1.063rem;
  position: relative;
  height: 1.063rem;
  overflow: hidden;
  flex-shrink: 0;
}
.message4 {
  flex: 1;
  position: relative;
  line-height: 100%;
}
.groupIcon {
  width: 1rem;
  position: relative;
  height: 1rem;
}
.image {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0.188rem;
}
.vectorIcon {
  width: 1.2rem;
  position: relative;
  height: 1.2rem;
  cursor: pointer;
}
.sendbutton {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0.125rem;
}
.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.938rem;
}
.messageinput {
  align-self: stretch;
  border-radius: 16px;
  background-color: #f0f2ff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0.3rem 1rem;
  gap: 0.5rem;
}
.message3 {
  /* width: 37.5rem; */
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.063rem;
  color: #919191;
}
.attachmentmessage {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 94%;
  margin: auto;
  border-radius: 12px;
  padding: 5px 10px;
  border: 1px solid #2d9cdb;
  background-color: #fff;
}
.downloadcursor {
  cursor: pointer;
}
.chatinput input {
  background-color: transparent;
  border: none;
  font-size: 16px;
  @media (min-width: 1700px) {
    font-size: 20px;
  }
}
.support {
  /* width: 37.5rem; */
  border-radius: 8px;
  background-color: #fff;
  height: calc(100vh - 80px);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  max-width: 37.5rem;
  text-align: left;
  font-size: 1.169rem;
  color: #fff;
  font-family: Poppins;
}
</style>

<style lang="scss">
.chatprimarybtn {
  background-color: transparent;
  border: none;
  padding: 0;
  &:hover {
    background-color: transparent;
  }
  &.is-disabled {
    background-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }
}
.is-disabled {
  .el-input__inner {
    background-color: transparent !important;
    &:hover {
      background-color: transparent;
    }
  }
}
.chatSendBtn {
  padding: 0;
  background-color: transparent !important;
  border: none !important;
}
.circle-design {
  border-radius: 50px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #273480; */
  overflow: hidden;
}
.movestatus {
  .el-dropdown .el-dropdown-selfdefine {
    border: 1px solid #2d9cdb;
    background-color: #ffffff;
    padding: 7px 10px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    color: #273480;
    font-weight: 500;
    cursor: pointer;
  }
}
.attached_block {
  display: flex;
  align-items: center;
  column-gap: 5px;
  width: 100%;
  overflow: hidden;
}
.attached_file_name {
  color: #273480;
  font-weight: 500;
  width: 185px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
</style>
